import axios from '../../../build/http-requests/axios-common'

export default {
  state: {
    selectedMenuItem: null,
    funcionalities: null,
    allowedFuncionalities: null,
    isOpen: false,
    currentPath: null
  },

  mutations: {
    MENU_ITEM_SELECTED (state, menu) {
      state.selectedMenuItem = menu
    },
    CLEAR_MENU_ITEM_SELECTED (state) {
      state.selectedMenuItem = null
    },
    SAVE_ALLOWED_FUNCIONALITIES (state, funcionalities) {
      state.allowedFuncionalities = funcionalities
    },
    CLEAN_FUNCTIONALITE_MODULE (state) {
      state.allowedFuncionalities = null
    },
    UPDATE_SIDEBAR_STATE (state, value) {
      state.isOpen = value
    },
    UPDATE_CURRENT_ROUTE (state, path) {
      state.currentPath = path
    }
  },

  actions: {
    getFuncionalities: ({ commit }) => {
      return new Promise((resolve, reject) => {
        axios.get('/home/functionalities')
          .then(response => {
            resolve(response)
          }).catch((error) => {
            reject(error)
          })
      })
    },

    selectMenuItem: ({ commit }, menu) => {
      return new Promise((resolve, reject) => {
        commit('MENU_ITEM_SELECTED', menu)
        resolve()
      })
    },

    clearSelectedMenuItem: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAR_MENU_ITEM_SELECTED')
        resolve()
      })
    },

    saveAllowedFuncionalities: ({ commit }, funcionalities) => {
      return new Promise((resolve, reject) => {
        commit('SAVE_ALLOWED_FUNCIONALITIES', funcionalities)
        resolve()
      })
    },

    cleanFunctionatieModule: ({ commit }) => {
      return new Promise((resolve, reject) => {
        commit('CLEAN_FUNCTIONALITE_MODULE')
        resolve()
      })
    },

    updateSidebarState: ({ commit }, value) => {
      commit('UPDATE_SIDEBAR_STATE', value)
    },

    currentRoute: ({ commit }, path) => {
      commit('UPDATE_CURRENT_ROUTE', path)
    }
  },

  getters: {
    selectedMenuItem: state => state.selectedMenuItem,
    funcionalities: state => state.funcionalities,
    allowedFuncionalities: state => state.allowedFuncionalities,
    isOpen: state => state.isOpen,
    currentPath: state => state.currentPath
  }
}



// WEBPACK FOOTER //
// ./client/store/modules/sidebarMenu.js